"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneCallConfirmationInfo = void 0;
var React = _interopRequireWildcard(require("react"));
var _SubtitleLayout = require("../SubtitleLayout");
var styles = _interopRequireWildcard(require("./PhoneCallConfirmationInfo.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PhoneCallConfirmationInfo = _ref => {
  let {
    phone
  } = _ref;
  return /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, {
    offset: _SubtitleLayout.ESubtitleOffset.XL
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['inner']
  }, "\u0417\u0432\u043E\u043D\u0438\u043C \u043D\u0430 ", /*#__PURE__*/React.createElement("strong", null, phone)));
};
exports.PhoneCallConfirmationInfo = PhoneCallConfirmationInfo;
PhoneCallConfirmationInfo.displayName = 'PhoneCallConfirmationInfo';